import MobiCopilotLogoComponent from 'modules/mobiCopilot/assets/MobiCopilotLogo';
import MobiCopilotWhiteIconComponent from 'modules/mobiCopilot/assets/MobiCopilotWhiteIcon';
import MobiCopilotGreenIconComponent from 'modules/mobiCopilot/assets/MobiCopilotGreenIcon';

export const MobiCopilotLogo = MobiCopilotLogoComponent;
export const MobiCopilotWhiteIcon = MobiCopilotWhiteIconComponent;
export const MobiCopilotGreenIcon = MobiCopilotGreenIconComponent;

export const MODULE_PRODUCT_NAME = 'MOBI_INTELIGENCIA_COPILOTO';

export const Z_INDEX_COMPONENT_LEVEL = 9999999999;
